import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
Vue.config.productionTip = false;
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import baseInfo from "@/components/baseInfo.vue";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
Vue.component("base-info", baseInfo);
Vue.use(ElementUI);
import ImageViewer from "vue2-viewer";
Vue.use(ImageViewer);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
